/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Profile_Api_Keys_One_Time_Modal_Saved_ButtonInputs */

const es_user_profile_api_keys_one_time_modal_saved_button = /** @type {(inputs: User_Profile_Api_Keys_One_Time_Modal_Saved_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ya la guardé`)
};

const en_user_profile_api_keys_one_time_modal_saved_button = /** @type {(inputs: User_Profile_Api_Keys_One_Time_Modal_Saved_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I have saved it`)
};

/**
* | output |
* | --- |
* | "I have saved it" |
*
* @param {User_Profile_Api_Keys_One_Time_Modal_Saved_ButtonInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const user_profile_api_keys_one_time_modal_saved_button = /** @type {((inputs?: User_Profile_Api_Keys_One_Time_Modal_Saved_ButtonInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Profile_Api_Keys_One_Time_Modal_Saved_ButtonInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_user_profile_api_keys_one_time_modal_saved_button(inputs)
	return en_user_profile_api_keys_one_time_modal_saved_button(inputs)
});
export { user_profile_api_keys_one_time_modal_saved_button as "user.profile.api_keys.one_time_modal.saved_button" }